import React from 'react';
import { useIntl } from 'react-intl';

import { Currency } from '@components';

import type { DetailHeaderProps } from './types';

import styles from './styles.module.scss';

export const DetailHeader: React.FC<DetailHeaderProps> = ({
  name,
  expiryText,
  totalPrice,
  currency,
}) => {
  const intl = useIntl();

  return (
    <div className={styles.headerRow}>
      <div className={styles.titleBlock}>
        <h1 className={styles.title}>{name}</h1>
        <p className={styles.expiry}>
          <span className={styles.expiryLabel}>
            {intl.formatMessage({ id: 'certificates.detail.expiryLabel' })}
          </span>{' '}
          {expiryText}
        </p>
      </div>
      <div className={styles.headerRight}>
        <p className={styles.totalPrice}>
          <Currency currency={currency} />
          {(totalPrice ?? 0).toFixed(2)}
        </p>
      </div>
    </div>
  );
};
